import { queryKeyPrefix } from 'src/features/tanStackQuery/queryKeyPrefix'

const prefix = queryKeyPrefix.productMaster

export const queryKeys = {
  products: [...prefix, 'products'],
  latestBatchJobStatus: [...prefix, 'latestBatchJobStatus'],
  masterFieldDefs: [...prefix, 'masterFieldDefs'],
  masters: [...prefix, 'masters'],
  master: (uuid: string) => [...prefix, 'master', uuid],
  masterTemplates: (uuid: string) => [...prefix, 'masterTemplates', uuid],
}
